// When the user scrolls the page, execute myFunction
window.onscroll = function() { headerFunction() };

function headerFunction() {
    if(window.pageYOffset > 50){
        if(!$('.xp-header').hasClass('bg-alt')){
            $('.xp-header').addClass('bg-alt');
        }        
    }else{
        if($('.xp-header').hasClass('bg-alt')){
            $('.xp-header').removeClass('bg-alt');   
        }
    }
}

function intlTelInputComponent(input) {
        input = document.querySelector(input);
        window.intlTelInput(input, {
            preferredCountries: ['br', 'es', 'us', 'gb'],
            utilsScript: "assets/components/intl-tel-input/build/js/utils.js",
            autoPlaceholder: "off",
            separateDialCode: true,
        });
}

(function($){
    $(window).on("load",function(){

        if( $('.navegation').length != 0 ){

            $(".navegation").mCustomScrollbar({
                theme:"minimal-dark"
            });

        }

        if( $('.navegation-2').length != 0 ){

            $(".navegation-2").mCustomScrollbar({
                theme:"inset-2-dark"
            });

        }

    });
})(jQuery);


function selectComponent() {
    if( $('.js-example-select2').length != 0 ){
        //select2    
        $('.js-control-bank').select2({
      language: {
        noResults: function () {
             return "Sem resultados";
        }
    }
    });
    }
    
    if( $('.js-example-select2-modal').length != 0 ){
        //select2
        $('.js-control-bank').select2({
            dropdownParent: $(".modal")
        });
    }
}

$(function(){

    
    if( $('.js-example-select2').length != 0 ){
        //select2    
        $('.js-example-select2').select2({
      language: {
        noResults: function () {
             return "Sem resultados";
        }
    }
    });
    }
    
    if( $('.js-example-select2-modal').length != 0 ){
        //select2
        $('.js-example-select2-modal').select2({
            dropdownParent: $(".modal")
        });
    }
    

    if( $('.js-input-datepicker').length != 0 ){
        //bootstrap datepicker
        $('.js-input-datepicker').datepicker({ 
            format: 'dd/mm/yyyy', 
            language: 'pt-BR',
            templates:{
                leftArrow: '<i class="fas fa-angle-left"></i>',
                rightArrow: '<i class="fas fa-angle-right"></i>'
            }
        });
    }

    
    // mascaras

    if( $('.mask-date').length != 0 ){
        $('.mask-date').mask('00/00/0000');
    }
    if( $('.mask-time').length != 0 ){
        $('.mask-time').mask('00:00:00');
    }
    if( $('.mask-date-time').length != 0 ){
        $('.mask-date-time').mask('00/00/0000 00:00:00');    
    }
    if( $('.mask-cep').length != 0 ){
        $('.mask-cep').mask('00000-000');
    }
    if( $('.mask-phone').length != 0 ){
        $('.mask-phone').mask('#0000-0000');
    }
    if( $('.mask-cpf').length != 0 ){
        $('.mask-cpf').mask('000.000.000-00', {reverse: true});
    }
    if( $('.mask-cnpj').length != 0 ){
        $('.mask-cnpj').mask('00.000.000/0000-00', {reverse: true});
    }
    if( $('.mask-money').length != 0 ){
        $('.mask-money').mask('#.##0,00', {reverse: true});        
    }
    if( $('.mask-number').length != 0 ){
        $('.mask-number').mask('#0', {reverse: true});
    }


    $('.js-ltr-ctrl-resp').click(function() {
        $('.xp-section-nav').toggleClass( "menu-resp-active" );
    });


    $('.inputGoTo').keyup(function(e){
        if(e.keyCode == 8){
            $(this).prev().val('').focus();
        }else{
            if($(this).val().length==$(this).attr("maxlength")){
                $(this).next().focus();
            }
        }
    });


    $('.ckeckAll').change(function(e) {
        if (e.currentTarget.checked) {
            $('tbody td').find('input[type="checkbox"]').prop('checked', true);
        } else {
            $('tbody td').find('input[type="checkbox"]').prop('checked', false);
        }
    });    


    $('.dropdown-xp').click(function(){
        $(this).find('.dropdown-menu').toggle()
    });


    $('.bt-chat-active').click(function(){
        $('.chat-overlay').toggleClass( "active" );
    });


});


/** showHide
 * mostra esconde linha de descrição em uma tabela
 */
function showHide(seletorShow, seletorHide=null){
    if(seletorHide !=  null){
        if($(seletorShow).css('display') == 'none'){
            $(seletorHide + ' .table-row-sh').slideUp();
            $(seletorShow).show();
            $(seletorShow + ' .table-row-sh').slideDown();
        }else{
            $(seletorShow + ' .table-row-sh').slideUp(400, function(){
                $(seletorShow).hide();
            });
        }
    }else{
        if($(seletorShow).css('display') == 'none'){
            $(seletorShow).show();
            $(seletorShow + ' .table-row-sh').slideDown();
        }else{            
            $(seletorShow + ' .table-row-sh').slideUp(400, function(){
                $(seletorShow).hide();
            });
        }
    }
    return false;
}



